import { useEffectOnce } from './useEffectOnce';

type UseMountEffectOutput = void;

export const useMountEffect = (callback: VoidFunction): UseMountEffectOutput => {
   useEffectOnce(() => {
      callback();
   });
};
